<script>
import TranslateRecipe from "./TranslateRecipe.vue";

export default {
  name: "TranslateSelect",
  components: {TranslateRecipe},
  data() {
    return {
      formData: {
        from: "",
        to: [],
      },
      showDialog: false,
    }
  },
  methods: {
    // 打开弹窗
    handleShow() {
      this.showDialog = true;
    },

    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if(!valid) return;
        this.showDialog = false;
        this.$refs.translateRecipe.show(this.formData);
      })
    },

    reset() {
      this.$refs.form.resetFields();
    },

    handleClose() {
      this.reset();
      this.formData.from  = this.lang;
    }
  },
  computed: {
    supportLangList() {
      return this.$store.getters.supportLang;
    },
    lang() {
      return this.$store.state.recipe?.lang;
    },
    rules() {
      return {
        from: {required: true, message: this.$t('lang.请选择源语言'), trigger: "change"},
        to: {required: true, message: this.$t('lang.请选择目标语言'), trigger: "change"},
      }
    }
  },
  watch: {
    lang: {
      handler(val) {
        this.formData.from = val;
      },
      immediate: true
    }
  }
}
</script>

<template>
  <div>
    <translate-recipe ref="translateRecipe" v-on="$listeners" />

    <el-dialog class="dialog" :visible.sync="showDialog" :title="$t('lang.请选择源语言和目标语言')" @close="handleClose" :close-on-click-modal="false">
      <el-form label-width="auto" :model="formData" ref="form" :rules="rules">
        <el-form-item :label="$t('lang.源语言')" prop="from">
          <el-select v-model="formData.from" disabled>
            <el-option :label="item.name" :value="item.value" v-for="(item, index) in supportLangList" :key="index" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.目标语言')" prop="to">
          <el-select v-model="formData.to" multiple filterable>
            <el-option :label="item.name" :value="item.value" v-for="(item, index) in supportLangList" :key="index" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleConfirm">{{$t('lang.确定')}}</el-button>
          <el-button @click="reset">{{$t('lang.重置')}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<style scoped>

/deep/.dialog .el-dialog {
  width: 400px;
  border-radius: 12px;
}

.el-select {
  width: 100%;
}

</style>
